/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line no-shadow
export enum CorrespondenceStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  PENDING_VALID = 'pending_valid',
}
